import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Pages/Config";

const Buyercontact = ({ buyerId }) => {
  const [phone, setPhone] = useState(null);

  useEffect(() => {
    const fetchBuyerContact = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/get_user_by_id.php?id=${buyerId}&t=${Date.now()}`
        );

        if (res.data.success && res.data.data) {
          const { phone_num } = res.data.data;
          setPhone(phone_num || null);
        } else {
          setPhone(null);
        }
      } catch (error) {
        console.error("Failed to fetch contact", error);
        setPhone(null);
      }
    };

    if (buyerId) {
      fetchBuyerContact();
    }
  }, [buyerId]);

  if (!phone) {
    return <span>Unknown Number</span>;
  }

  return (
    <a
      href={`tel:${phone}`}
      style={{
        textDecoration: "none",
        color: "blue !important",
        fontSize: "13px",
      }}
    >
      {phone}
    </a>
  );
};

export default Buyercontact;
